import type React from 'react';
import {
  AlmostEqualFilled,
  BookmarkBd,
  BookmarkFilled,
  BookmarkMd,
  ChatFilled,
  ChatMd,
  ChatOffFilled,
  Checked,
  CheckMd,
  ChevronArrowDownBd,
  ChevronArrowDownMd,
  ChevronArrowLeftMd,
  ChevronArrowRightBd,
  ChevronArrowRightMd,
  ChevronArrowUpBd,
  CloseFilled,
  CloseMd,
  ContactMd,
  Determinate,
  DoubleArrowDownMd,
  EmojiBd,
  ErrorFilled,
  FoldLeftMd,
  FoldRightMd,
  ForwardingFilled,
  HeartFilled,
  HomeFilled,
  HomeMd,
  KeyboardMd,
  LiveFilled,
  LiveMd,
  NoticeFilled,
  PauseFilled,
  PickFilled,
  PickMd,
  PiPexitFilled,
  PlayFilled,
  PoliceMd,
  RankingFilled,
  RankingMd,
  RefreshLt,
  SearchMd,
  SettingMd,
  SubtitleOffFilled,
  SubtitleOnFilled,
  TooltipMd,
  TranslateFilled,
  TuneMd,
  TypoMd,
  UserFanMd,
  UserOffFilled,
  UserOffMd,
  VolumeOffFilled,
  VolumeOnFilled,
} from './components';
import ContactFilled from './components/ContactFilled';

// 정적 import 화이트리스트: eager=true일 때 즉시 렌더가 필요한 아이콘만 넣습니다.
// 번들 크기를 위해 필요한 항목만 점진적으로 추가하세요.
export const eagerIconComponents: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  AlmostEqualFilled,
  ChatOffFilled,
  CloseMd,
  VolumeOnFilled,
  VolumeOffFilled,
  PlayFilled,
  PauseFilled,
  ChevronArrowRightBd,
  CloseFilled,
  ChevronArrowRightMd,
  ForwardingFilled,
  SearchMd,
  HeartFilled,
  BookmarkFilled,
  BookmarkMd,
  BookmarkBd,
  TranslateFilled,
  ChevronArrowUpBd,
  ChevronArrowDownBd,
  ChevronArrowDownMd,
  ChevronArrowLeftMd,
  NoticeFilled,
  FoldRightMd,
  FoldLeftMd,
  SettingMd,
  UserFanMd,
  ChatFilled,
  PoliceMd,
  EmojiBd,
  KeyboardMd,
  Checked,
  Determinate,
  TuneMd,
  TypoMd,
  ChatMd,
  CheckMd,
  RefreshLt,
  TooltipMd,
  HomeFilled,
  HomeMd,
  PickFilled,
  PickMd,
  UserOffFilled,
  UserOffMd,
  SubtitleOffFilled,
  SubtitleOnFilled,
  PiPexitFilled,
  LiveMd,
  LiveFilled,
  RankingMd,
  RankingFilled,
  ContactMd,
  ContactFilled,
  DoubleArrowDownMd,
  ErrorFilled,
};
